import * as React from 'react';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const CustomButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  borderRadius: '50%',
  color: '#ffffff',
  fontSize: '12px',
  fillRule: 'evenodd',
  minWidth: 'auto',
  textTransform: 'none',
  backgroundColor: 'rgba(255,255,255,0.09803921568627451 )',
  padding: '10px',
  '&:hover': {
    backgroundColor: '#36899f',
    boxShadow: 'none',
  },
  boxShadow: 'none',
  '& img': {
    filter: 'brightness(0) invert(1)',
  },
}));

const GlobalButton = styled(CustomButton)(({ theme }) => ({
  background: 'rgba(255,255,255,0.09803921568627451 )',
  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.09803921568627451 )',
  },
}));

const YellowButton = styled(CustomButton)(({ theme }) => ({
  background: '#ddb930',
  '&:hover': {
    backgroundColor: '#ddb930',
  },
}));

const SkyButton = styled(CustomButton)(({ theme }) => ({
  background: '#36899f',
  '&:hover': {
    backgroundColor: '#36899f',
  },
}));

const RedButton = styled(CustomButton)(({ theme }) => ({
  background: '#fc1c03',
  '&:hover': {
    backgroundColor: '#fc1c03',
  },
}));

const ButtonText = styled(Typography)(({ theme }) => ({
  fontSize: '.8rem',
  marginLeft: '.2rem',
}));

interface smallButtonProps {
  color?: string;
  text?: string;
  icon: any;
  isClicked?: boolean;
  style?: Object;
  onClick?: any;
  width?: string;
  height?: string;
  disabled?: boolean;
}

const SmallButton: React.FC<smallButtonProps> = ({
  color,
  icon,
  isClicked,
  style,
  onClick,
  text,
  width = '20px',
  height = '20px',
  disabled,
}) => {
  return color === 'yellow' && isClicked === true ? (
    <YellowButton
      disabled={disabled}
      variant="contained"
      style={style}
      onClick={onClick}
    >
      <img src={icon} alt="" width={width} height={height} />
      {text && <ButtonText>{text}</ButtonText>}
    </YellowButton>
  ) : color === 'sky' && isClicked === true ? (
    <SkyButton
      disabled={disabled}
      variant="contained"
      style={style}
      onClick={onClick}
    >
      <img src={icon} alt="" width={width} height={height} />
      {text && <ButtonText>{text}</ButtonText>}
    </SkyButton>
  ) : color === 'red' && isClicked === true ? (
    <RedButton
      disabled={disabled}
      variant="contained"
      style={style}
      onClick={onClick}
    >
      <img src={icon} alt="" width={width} height={height} />
      {text && <ButtonText>{text}</ButtonText>}
    </RedButton>
  ) : color === 'none' && isClicked === true ? (
    <GlobalButton
      disabled={disabled}
      variant="contained"
      style={style}
      onClick={onClick}
    >
      <img src={icon} alt="" width={width} height={height} />
      {text && <ButtonText>{text}</ButtonText>}
    </GlobalButton>
  ) : (
    <GlobalButton
      disabled={disabled}
      variant="contained"
      style={style}
      onClick={onClick}
    >
      <img src={icon} alt="" width={width} height={height} />
      {text && <ButtonText>{text}</ButtonText>}
    </GlobalButton>
  );
};

export default SmallButton;
